<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Kode Referral' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Kode Referral</h3>

        <v-card>
            <v-card-title>
                Daftar Kode Referral
                <v-spacer></v-spacer
                ><v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="showDialog = true"
                    ><v-icon small class="pr-2">mdi-download</v-icon>
                    Export Excel
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="codeList"
                :headers="headers"
                :has-custom-pagination="true"
                :has-custom-search="true"
                :custom-pagination-total-items="pagination.total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="detailReferral()"
                v-on:doSearch="
                    search = { query: $event.value, by: $event.key.value };
                    doFilter();
                "
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
            ></app-datatable>
        </v-card>

        <v-dialog
            v-if="showDialog"
            v-model="showDialog"
            max-width="509px"
            @click:outside="showDialog = false"
        >
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    Export
                </v-card-title>
                <v-card-text class="mt-8">
                    <v-row class="ml-0">
                        <v-col cols="12" md="12">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <div
                                        style="font-size: 14px"
                                        class="mb-2 font-weight-bold"
                                    >
                                        Dari Tanggal
                                    </div>
                                    <div>
                                        <v-dialog
                                            ref="dialog"
                                            v-model="modal_date"
                                            :return-value.sync="start_date"
                                            persistent
                                            width="290px"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="start_date"
                                                    outlined
                                                    dense
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="start_date"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal_date = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="
                                                        $refs.dialog.save(
                                                            start_date
                                                        )
                                                    "
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div
                                        style="font-size: 14px"
                                        class="mb-2 font-weight-bold"
                                    >
                                        Sampai Tanggal
                                    </div>
                                    <div>
                                        <v-dialog
                                            ref="dialog2"
                                            v-model="modal_date2"
                                            :return-value.sync="end_date"
                                            persistent
                                            width="290px"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-text-field
                                                    v-model="end_date"
                                                    outlined
                                                    dense
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="end_date"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal_date2 = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="
                                                        $refs.dialog2.save(
                                                            end_date
                                                        )
                                                    "
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <div style="font-size: 14px" class="grey--text">
                        Tanggal penggunaan kode referral
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="darkFade" text @click="showDialog = false">
                        Tutup
                    </v-btn>
                    <v-btn
                        color="blew"
                        class="white--text"
                        @click="exportCode()"
                    >
                        Export Data
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import Spinner from "@/modules/global/components/plugins/Spinner";
import SalesService from "@/modules/global/services/sales.js";

export default {
    name: "referral-code",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            codeList: [],
            selectedRow: null,
            search: "",
            showDialog: false,
            modal_date: false,
            modal_date2: false,
            start_date: "",
            end_date: "",
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                total_data: 0,
                sortMode: "desc",
            },
            filter: {
                email: "",
                referral_code: "",
                school: "",
                page: 1,
                per_page: 10,
            },
            params: {
                start_date: "",
                end_date: "",
            },
            headers: [
                { text: "Email Pemilik", value: "email" },
                { text: "Nomor Telepon", value: "phone_number", width: "200" },
                { text: "Kode Referral", value: "referral_code", width: "150" },
                { text: "Jumlah Penggunaan", value: "usage_count" },
                { text: "Sekolah", value: "school" },
            ],
            headersKey: ["email", "referral_code", "usage_count", "school"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        search() {
            this.fetchData();
        },
        pagination() {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;

            this.filter = {
                email: "",
                referral_code: "",
                school: "",
                page: context.pagination.currentPage,
                per_page: context.pagination.perPage,
            };

            if (!this.search.by || !this.search.query) {
                this.clearFilter();
            } else {
                this.filter[this.search.by] = this.search.query;
            }

            if (this.search.length > 0) {
                this.search.forEach((data) => {
                    if (data.key.value === "email") {
                        this.filter.email = data.value;
                    }
                    if (data.key.value === "referral_code") {
                        this.filter.referral_code = data.value;
                    }
                    if (data.key.value === "usage_count") {
                        this.filter.usage_count = data.value;
                    }
                    if (data.key.value === "school") {
                        this.filter.school = data.value;
                    }
                });
            }

            this.isLoading = true;
            SalesService.getListReferralCode(this.filter, function (result) {
                context.codeList = [];

                if (result.success) {
                    context.pagination.totalPages = result.data.max_page;
                    context.pagination.total_data = result.data.total_data;
                    result.data.data.forEach(function (content, index) {
                        var row = {
                            no: index,
                            id: content.id,
                            email: content.email,
                            referral_code: content.referral_code,
                            usage_count: content.usage_count,
                            phone_number: content.phone_number,
                            school: content.school,
                        };

                        context.codeList.push(row);
                    });
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },

        clearFilter() {
            this.params = {
                page: 1,
                per_page: this.pagination.perPage,
                email: "",
                referral_code: "",
                school: "",
            };
        },

        detailReferral: function () {
            var codeId = this.selectedRow.id;
            this.$router.push({
                path: "/referral-code-detail",
                query: { id: codeId },
            });
        },

        doFilter() {
            this.params.page = 1;
            this.pagination.currentPage = 1;
            this.fetchData();
        },

        exportCode() {
            var context = this;

            let timestamp;
            let timestamp2;

            if (this.start_date !== "" && this.end_date !== "") {
                timestamp = new Date(this.start_date).getTime();
                timestamp2 = new Date(this.end_date).getTime();
            }

            context.params = {
                start_date: timestamp,
                end_date: timestamp2,
            };

            SalesService.exportReferralCodeList(
                context.params,
                function (result) {
                    context.isLoading = false;
                    if (result.success) {
                        context.downloadFIle(result.data);
                        context.$store.commit("showAlert", {
                            message: `Berhasil export data`,
                            type: "success",
                        });
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal export data`,
                            type: "error",
                        });
                    }
                    return;
                }
            );
        },

        getTodayDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, "0");
            const day = String(today.getDate()).padStart(2, "0");

            return `${year}-${month}-${day}`;
        },

        downloadFIle(byteArray) {
            const formattedDate = this.getTodayDate();

            const url = window.URL.createObjectURL(
                new Blob([byteArray], {
                    type: "application/vnd.ms-excel",
                })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                "Kode Referral_" + formattedDate + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
        },
    },
};
</script>



// WEBPACK FOOTER //
// ReferralCode.vue?0ace1590